import { newDiv } from '../RenderUtils';
import { addEvents } from './Events';

export class HelpControl {
  constructor(container) {
    this.container = container;
  }

  render(action, SendAction) {
    const classContainer = 'HelpControl';

    const actionsDiv = newDiv(null, this.container);
    actionsDiv.classList.add(classContainer);

    addEvents(actionsDiv, action, SendAction);
  }
}
